import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const VersionNotificationModal = ({ visible }) => {
  const { t } = useTranslation();
  const CURRENT_VERSION = '1.6.0'; // Example version, adjust as needed

  if (!visible) return null;

  const handleReload = () => {
    window.location.reload(true); // Hard refresh
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleReload();
    }
  };

  const currentDate = new Date().toLocaleString("en-US", {
    timeZone: "Asia/Kolkata",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onKeyDown={handleKeyDown}
      aria-label="Version Update Notification"
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid #e0e0e0",
          borderRadius: "12px",
          padding: "40px",
          width: "600px",
          minHeight: "350px",
          textAlign: "center",
          color: "#333333",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
          position: "relative",
          fontFamily: "'Roboto', sans-serif",
        }}
      >
        {/* Disabled Close Button */}
        <button
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            background: "transparent",
            border: "none",
            color: "#666666",
            fontSize: "20px",
            cursor: "not-allowed",
            opacity: 0.5,
          }}
          disabled
        >
          ×
        </button>

        {/* Logo and Version */}
        <img
          src="https://netshine-assets.blr1.cdn.digitaloceanspaces.com/web-assets/logo-light.png"
          alt="Netshine Office"
          style={{
            width: "250px",
            marginBottom: "20px",
          }}
        />
   

        <h2
          style={{
            fontSize: "28px",
            fontWeight: "700",
            marginBottom: "20px",
            color: "#004d40",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          <span style={{ color: "#2e7d32", marginRight: "8px" }}>✔</span>
          {t("new_version_available")}
        </h2>

        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
            marginBottom: "30px",
            color: "#333333",
            padding: "0 20px",
          }}
        >
          {t("update_notification_message", {
            date: currentDate,
            features: "enhanced reporting, performance optimization, and security patches",
          })}
          <br />
          <span style={{ color: "#666666" }}>Some features may be unavailable until you reload.</span>
        </p>

        <button
          onClick={handleReload}
          style={{
            backgroundColor: "#1976d2",
            color: "#ffffff",
            fontWeight: "600",
            padding: "15px 40px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background 0.3s ease, box-shadow 0.3s ease",
            width: "200px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#1565c0";
            e.target.style.boxShadow = "0 0 8px rgba(25, 118, 210, 0.5)";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "#1976d2";
            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
          }}
          aria-label="Reload Application"
        >
          {t("reload_now")}
        </button>
      </div>
      <style jsx>{`
        @media (max-width: 768px) {
          div[style*="width: 600px"] {
            width: 90%;
            max-width: 600px;
          }
        }
      `}</style>
    </div>
  );
};

export default VersionNotificationModal;